import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

// Initialize app
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  // Ensure we start at top on first load
  window.scrollTo(0, 0);
  
  if ('requestAnimationFrame' in window) {
    requestAnimationFrame(() => {
      // Mark root as ready to show content
      const root = document.getElementById('root');
      if (root) root.classList.add('ready');
    });
  } else {
    setTimeout(() => {
      const root = document.getElementById('root');
      if (root) root.classList.add('ready');
    }, 0);
  }
}

// Error boundary for production
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
